<template lang="pug">
div.container-fluid.animated.fadeIn
  nav(aria-label="breadcrumb")
    b-breadcrumb
      b-breadcrumb-item
        router-link(to="/match")
          i.fa.fa-gamepad
          span.ml-1 {{ $t("ui.match") }}
      b-breadcrumb-item
        router-link(to="/match/cmdsbomapmatch")
          i.fa.fa-link
          span.ml-1 {{ $t("ui.cmd_sbo_mapping") }}
  div.row
    div.col-md-12
      div.card
        div.card-header
          div.row
            div.col-md-12.mb-1
              div.form-row
                div.col-md-2.mb-1
                  b-input-group(size="sm")
                    b-input-group-text(slot="prepend")
                      i.fas.fa-basketball-ball
                    b-form-select(v-model="sportType" autofocus)
                      option(v-for="sportInfo in sportList" v-bind:value="sportInfo.sport_id")
                        | {{ sportInfo.sport_type }}
                div.col-md-2.mb-1
                  b-input-group(size="sm")
                    b-input-group-text(slot="prepend")
                      i.fas.fa-link
                    b-form-select(v-model="linked" @change="changeMap")
                      option(value="false") {{ $t('ui.not_mapped') }}
                      option(value="true") {{ $t('ui.mapped') }}
          div.row
            div.col-md-12.mb-1
              div.form-row
                div.col-md-2.mb-1
                  b-input-group(size="sm")
                    b-input-group-text(slot="prepend")
                      i.far.fa-clock
                    b-form-select(v-model="marketType" @change="marketOnChange($event)")
                      option(value="") {{ $t('ui.all') }}
                      option(value="early") {{ $t('ui.early') }}
                      option(value="today") {{ $t('ui.today') }}
                      option(value="live") {{ $t("ui.live") }}
                div.col-md-2.mb-1(v-if="marketType != ''")
                  b-input-group(size="sm")
                    b-input-group-text(slot="prepend")
                      span {{ $t("ui.from") }}
                    date-picker(v-model="startDate" :config="locale")
                div.col-md-2.mb-1(v-if="marketType != ''")
                  b-input-group(size="sm")
                    b-input-group-text(slot="prepend")
                      span {{ $t("ui.to") }}
                    date-picker(v-model="endDate" :config="locale")
                div.col-md-2.mb-1
                  SubmitButton(
                    :loading="loading"
                    icon="fa fa-search"
                    :text="$t('ui.search')"
                    type="button"
                    @click="getMatchList()"
                    variant="success"
                    size="sm"
                    ).mb-1.mr-2
                  SubmitButton(
                      :loading="loading"
                      icon="fa fa-link"
                      :text="$t('ui.map')"
                      type="button"
                      @click="mapMatch()"
                      variant="secondary"
                      size="sm"
                      v-if="firstMatchIdSelected!='' && secondMatchIdSelected !='' && curLinkedValue == 'false'"
                    ).mb-1.mr-2
        div.card-body
          div.row.mb-5
            // SBO
            div.col-6
              div.row.mb-2
                div.col-md-2
                  b-input-group(size="sm")
                    b-input(:value="firstProvider" readonly)
                    b-input(:value="filterFirstMatchListLength" readonly)
                div.col-md-7
                  b-input-group(size="sm")
                    b-input-group-text(slot="prepend")
                      i.fas.fa-search
                    DebounceInput(required type="text" v-model="firstMatchSearch" :placeholder="$t('message.search_by_team_name')").mr-1
                    b-form-radio-group(
                      buttons
                      v-model="matchFilterBy"
                      size="sm"
                      button-variant="outline-info"
                    )
                      b-form-radio(value="match_id") {{ $t("ui.id") }}
                      b-form-radio(value="league_name") {{ $tc("ui.leagues", 1) }}
                      b-form-radio(value="home_team") {{ $t("ui.home") }}
                      b-form-radio(value="away_team") {{ $t("ui.away") }}
              div.row.mb-1
                div.col-12.clusterize
                  div#tblFirstMatch.clusterize-scroll
                    table.tablex(v-columns-resizable)
                      thead
                        tr
                          th.sticky-position(style="width: 10%;" @click="sortOrder('match_id', 'first')")
                            span {{ $t('ui.id') }}
                            i(:class="changeSortKey('match_id', 'first')")
                          th.sticky-position(style="width: 10%;" @click="sortOrder('sport_type', 'first')")
                            span {{ $tc('ui.sports', 1) }}
                            i(:class="changeSortKey('sport_type', 'first')")
                          th.sticky-position(style="width: 30%;" @click="sortOrder('league_name', 'first')")
                            span {{ $tc('ui.leagues', 1) }}
                            i(:class="changeSortKey('league_name', 'first')")
                          th.sticky-position(style="width: 10%;" @click="sortOrder('match_date', 'first')")
                            span {{ $t('ui.short.match_date') }}
                            i(:class="changeSortKey('match_date', 'first')")
                          th.sticky-position(style="width: 20%;" @click="sortOrder('home_team', 'first')")
                            span {{ $t('ui.home') }}
                            i(:class="changeSortKey('home_team', 'first')")
                          th.sticky-position(style="width: 20%;" @click="sortOrder('away_team', 'first')")
                            span {{ $t('ui.away') }}
                            i(:class="changeSortKey('away_team', 'first')")
                      tbody.clusterize-content
                        tr(
                          v-for="(firstMatchInfo, index) in filterFirstMatchList"
                          @click="rowSelect(firstMatchInfo, 'firstMatch')"
                          :class="{ 'selectedRow' : selectedRow(firstMatchInfo, 'firstMatch') }"
                          :ref="firstMatchInfo.match_id"
                          )
                          td
                            span {{ firstMatchInfo.match_id }}
                          td
                            span {{ firstMatchInfo.sport_type }}
                          td
                            span(:title="firstMatchInfo.league_name + ' [' + firstMatchInfo.league_id + ']'") {{ firstMatchInfo.league_name }}
                          td
                            span {{ $moment(firstMatchInfo.match_date).format("DD-MM-YYYY") }}
                          td
                            span(:title="firstMatchInfo.home_team + ' [' + firstMatchInfo.home_id + ']'") {{ firstMatchInfo.home_team }}
                          td
                            span(:title="firstMatchInfo.away_team + ' [' + firstMatchInfo.away_id + ']'") {{ firstMatchInfo.away_team }}
            // SBO
            div.col-6
              div.row.mb-2
                div.col-md-2
                  div.col-md-2
                  b-input-group(size="sm")
                    b-input(:value="secondProvider" readonly)
                    b-input(:value="filterSecondMatchListLength" readonly)
                div.col-md-7
                  b-input-group(size="sm")
                    b-input-group-text(slot="prepend")
                      i.fas.fa-search
                    DebounceInput(required type="text" v-model="secondMatchSearch" :placeholder="$t('message.search_by_team_name')").mr-1
                    b-form-radio-group(
                      buttons
                      v-model="matchFilterBy"
                      size="sm"
                      button-variant="outline-info"
                    )
                      b-form-radio(value="match_id") {{ $t("ui.id") }}
                      b-form-radio(value="league_name") {{ $tc("ui.leagues", 1) }}
                      b-form-radio(value="home_team") {{ $t("ui.home") }}
                      b-form-radio(value="away_team") {{ $t("ui.away") }}
              div.row.mb-1
                div.col-12.clusterize
                  div#tblSecondMatch.clusterize-scroll
                    table.tablex(v-columns-resizable)
                      thead
                        tr
                          th.sticky-position(style="width: 10%;" @click="sortOrder('match_id', 'second')")
                            span {{ $t('ui.id') }}
                            i(:class="changeSortKey('match_id', 'second')")
                          th.sticky-position(style="width: 10%;" @click="sortOrder('sport_type', 'second')")
                            span {{ $tc('ui.sports', 1) }}
                            i(:class="changeSortKey('sport_type', 'second')")
                          th.sticky-position(style="width: 30%;" @click="sortOrder('league_name', 'second')")
                            span {{ $tc('ui.leagues', 1) }}
                            i(:class="changeSortKey('league_name', 'second')")
                          th.sticky-position(style="width: 10%;" @click="sortOrder('match_date', 'second')")
                            span {{ $t('ui.short.match_date') }}
                            i(:class="changeSortKey('match_date', 'second')")
                          th.sticky-position(style="width: 20%;" @click="sortOrder('home_team', 'second')")
                            span {{ $t('ui.home') }}
                            i(:class="changeSortKey('home_team', 'second')")
                          th.sticky-position(style="width: 20%;" @click="sortOrder('away_team', 'second')")
                            span {{ $t('ui.away') }}
                            i(:class="changeSortKey('away_team', 'second')")
                      tbody.clusterize-content
                        tr(
                          v-for="(secondMatchInfo, index) in filterSecondMatchList"
                          @click="rowSelect(secondMatchInfo, 'secondMatch')"
                          :class="{ 'selectedRow' : selectedRow(secondMatchInfo, 'secondMatch') }"
                          :ref="secondMatchInfo.match_id"
                          )
                          td
                            span {{ secondMatchInfo.match_id }}
                          td
                            span {{ secondMatchInfo.sport_type }}
                          td
                            span(:title="secondMatchInfo.league_name + ' [' + secondMatchInfo.league_id + ']'") {{ secondMatchInfo.league_name }}
                          td
                            span {{ $moment(secondMatchInfo.match_date).format("DD-MM-YYYY") }}
                          td
                            span(:title="secondMatchInfo.home_team + ' [' + secondMatchInfo.home_id + ']'") {{ secondMatchInfo.home_team }}
                          td
                            span(:title="secondMatchInfo.away_team + ' [' + secondMatchInfo.away_id + ']'") {{ secondMatchInfo.away_team }}
</template>
<script>
import config from "@/config";
import preadd from "@/preadd";
import errorTags from "@/errorTags";
import SubmitButton from "@/library/SubmitButton.vue";
import DebounceInput from "@/library/DebounceInput";
import VueScrollTo from "vue-scrollto";

export default {
  components: {
    SubmitButton,
    DebounceInput,
    VueScrollTo
  },
  data: () => ({
    loading: false,
    sportType: 1,
    sportList: [],
    feedback: {
      success: false,
      status: errorTags.request.failed
    },
    firstMatchList: [],
    secondMatchList: [],
    firstProvider: "SBO",
    secondProvider: "CMD",
    curLinkedValue: "",
    linked: "false",
    firstMatchIdSelected: "",
    secondMatchIdSelected: "",
    firstMatchSelected: {},
    secondMatchSelected: {},
    firstSortKey: "league_name",
    firstSortType: "asc",
    secondSortKey: "league_name",
    secondSortType: "asc",
    matchFilterBy: "league_name",
    startDate: null,
    endDate: null,
    marketType: "today",
    locale: {
      format: "YYYY-MM-DD",
      useCurrent: true
    },
    canFindPair: false,
    fms: "",
    sms: ""
  }),
  computed: {
    today() {
      return this.$moment(new Date).format('YYYY-MM-DD');
    },
    todayWD() {
      return this.$moment(new Date).add(-12, 'hours').format('YYYY-MM-DD');
    },
    tomorrowWD() {
      return this.$moment(new Date).add(1, 'days').add(-12, 'hours').format('YYYY-MM-DD');
    },
    yesterday() {
      return this.$moment(new Date).add(-1, 'days').format('YYYY-MM-DD');
    },
    filterFirstMatchListLength() {
      if (this.filterFirstMatchList) {
        return this.filterFirstMatchList.length;
      } else {
        return 0;
      }
    },
    filterFirstMatchList() {
      return this.firstMatchList.filter(item => {
        if (this.matchFilterBy == "league_name") return item.league_name.toLowerCase().indexOf(this.firstMatchSearch.toLowerCase()) > -1;
        else if (this.matchFilterBy == "home_team") return item.home_team.toLowerCase().indexOf(this.firstMatchSearch.toLowerCase()) > -1;
        else if (this.matchFilterBy == "away_team") return item.away_team.toLowerCase().indexOf(this.firstMatchSearch.toLowerCase()) > -1;
        else if (this.matchFilterBy == "match_id") return item.match_id.toString().indexOf(this.firstMatchSearch) > -1;
      })
      .sort((a, b) => {
        if (this.firstSortType == 'asc')
          return a[this.firstSortKey] > b[this.firstSortKey] ? 1 : -1;
        else
          return a[this.firstSortKey] < b[this.firstSortKey] ? 1 : -1;
      });
    },
    firstMatchSearch:
    {
      get() {
        return this.fms;
      },
      set(value) {
        this.fms = value;
        this.sms = value;
      }
    },
    secondMatchSearch:
    {
      get() {
        return this.sms;
      },
      set(value) {
        this.sms = value;
      }
    },
    filterSecondMatchListLength() {
      if (this.filterSecondMatchList) {
        return this.filterSecondMatchList.length;
      } else {
        return 0;
      }
    },
    filterSecondMatchList() {
      return this.secondMatchList.filter(item => {
        if (this.matchFilterBy == "league_name") return item.league_name.toLowerCase().indexOf(this.secondMatchSearch.toLowerCase()) > -1;
        else if (this.matchFilterBy == "home_team") return item.home_team.toLowerCase().indexOf(this.secondMatchSearch.toLowerCase()) > -1;
        else if (this.matchFilterBy == "away_team") return item.away_team.toLowerCase().indexOf(this.secondMatchSearch.toLowerCase()) > -1;
        else if (this.matchFilterBy == "match_id") return item.match_id.toString().indexOf(this.secondMatchSearch) > -1;
      })
      .sort((a, b) => {
        if (this.secondSortType == 'asc')
          return a[this.secondSortKey] > b[this.secondSortKey] ? 1 : -1;
        else
          return a[this.secondSortKey] < b[this.secondSortKey] ? 1 : -1;
      });
    }
  },
  beforeDestroy() {
    this.sportList = [];
    this.firstMatchList = [];
    this.secondMatchList = [];
  },
  mounted: function() {
    this.getSportList();
    this.startDate = this.yesterday;
    this.endDate = this.today;
  },
  methods: {
    marketOnChange(eventStatus) {
      if (eventStatus == '') {
        this.startDate = this.yesterday;
        this.endDate = this.today;
      }
      else if (eventStatus == 'early') {
        this.startDate = this.tomorrowWD;
        this.endDate = this.tomorrowWD;
      } else if (eventStatus == 'today' || eventStatus == 'live') {
        this.startDate = this.todayWD;
        this.endDate = this.todayWD;
      }
    },
    sortOrder(key, type) {
      if (type == 'first') {
        if (this.firstSortKey == key)
          this.firstSortType = this.firstSortType == 'asc' ? 'desc' : 'asc';
        else {
          this.firstSortKey = key;
          this.firstSortType = 'asc';
        }
      } else if (type == 'second') {
        if (this.secondSortKey == key)
          this.secondSortType = this.secondSortType == 'asc' ? 'desc' : 'asc';
        else {
          this.secondSortKey = key;
          this.secondSortType = 'asc';
        }
      }
    },
    changeSortKey(key, type) {
      if (type == 'first') {
        if (this.firstSortKey != key)
          return 'fas fa-sort';
        else if (this.firstSortKey == key && this.firstSortType == 'asc')
          return 'fa fa-sort-up';
        else if (this.firstSortKey == key && this.firstSortType == 'desc')
          return 'fa fa-sort-down';
      } else if (type == 'second') {
        if (this.secondSortKey != key)
          return 'fas fa-sort';
        else if (this.secondSortKey == key && this.secondSortType == 'asc')
          return 'fa fa-sort-up';
        else if (this.secondSortKey == key && this.secondSortType == 'desc')
          return 'fa fa-sort-down';
      }
    },
    changeMap: function() {
      this.getMatchList();
    },
    getDate(dateTime) {
      let convertDateFormat = new this.$moment(dateTime).format("YYYY-MM-DD");
      return convertDateFormat;
    },
    getSportList: function() {
      let url = config.sportListUrl();

      var json = {
        action_by: this.$store.getters.username,
        session_token: this.$store.getters.sessionToken,
        page_id: config.accessRoles.cmdsbomapmatch
      };

      this.$http.post(url, json).then(
        function(response) {
          // Success
          try {
            if (response) {
              this.feedback.success = typeof response.data.status == "string" ? response.data.status == "1" : response.data.status == 1;

              this.feedback.status = response.data.statusdesc;
              if (this.feedback.success == true) {
                this.sportList = [];
                this.sportList = response.data.tbl_sport_list.filter(item => { return item.sport_id == 1; });
              } else {
                if (!this.$helpers.handleFeedback(this.feedback.status)) this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
              }
            }
          } catch (error) {
            this.feedback.success = false;
            this.feedback.status = errorTags.request.failed;
            this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
          }
        },
        function(response) {
          // Error
          this.feedback.success = false;
          this.feedback.status = errorTags.request.failed;
          this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
        }
      );
    },
    getMatchList: function() {
      this.reset();

      this.curLinkedValue = this.linked;

      let url = config.cmdSBOMapMatchListUrl();

      var json = {
        action_by: this.$store.getters.username,
        session_token: this.$store.getters.sessionToken,
        page_id: config.accessRoles.cmdsbomapmatch,
        sport_id: this.sportType,
        linked: this.linked,
        map_from: this.firstProvider.toLowerCase(),
        map_to: this.secondProvider.toLowerCase(),
        market_type: this.marketType,
        match_date_from: this.startDate,
        match_date_to: this.endDate,
        ignore_date_range: this.marketType == '' ? true : false,
        sort_key: this.sortKey,
        sort_type: this.sortType
      };

      this.loading = true;
      this.$http.post(url, json).then(
        function(response) {
          // Success
          this.loading = false;
          try {
            if (response) {
              this.feedback.success = typeof response.data.status == "string" ? response.data.status == "1" : response.data.status == 1;

              this.feedback.status = response.data.statusdesc;
              if (this.feedback.success == true) {
                this.firstMatchList = [];
                this.secondMatchList = [];
                this.firstMatchList = response.data.tbl_map_match_list.Table;
                this.secondMatchList = response.data.tbl_map_match_list.Table1;
              } else {
                if (!this.$helpers.handleFeedback(this.feedback.status)) this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
              }
            }
          } catch (error) {
            this.feedback.success = false;
            this.feedback.status = errorTags.request.failed;
            this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
          }
        },
        function(response) {
          // Error
          this.loading = false;
          this.feedback.success = false;
          this.feedback.status = errorTags.request.failed;
          this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
        }
      );
    },
    selectedRow: function(info, type) {
      if (type == "firstMatch") {
        if (this.firstMatchIdSelected == info.match_id) return true;
      } else if (type == "secondMatch") {
        if (this.secondMatchIdSelected == info.match_id) return true;
      }

      return false;
    },
    rowSelect: function(matchInfo, type) {
      if (this.curLinkedValue == "true") {
        if (type == "firstMatch") {
          this.firstMatchIdSelected = matchInfo.match_id;

          if (
            this.secondMatchList.filter(item => {
                return item.match_id == (this.secondProvider == 'CMD' ? matchInfo.cmd_match_id : matchInfo.sbo_match_id);
            }).length > 0
          ) {
            this.secondMatchIdSelected = this.secondMatchList.filter(item => {
              return item.match_id == (this.secondProvider == 'CMD' ? matchInfo.cmd_match_id : matchInfo.sbo_match_id);
            })[0].match_id;
            this.canFindPair = false;
          } else {
            this.secondMatchIdSelected = "";
            this.canFindPair = true;
          }
        } else if (type == "secondMatch") {
          this.secondMatchIdSelected = matchInfo.match_id;

          if (
            this.firstMatchList.filter(item => {
              return item.match_id == (this.firstProvider == 'CMD' ? matchInfo.cmd_match_id : matchInfo.sbo_match_id);
            }).length > 0
          ) {
            this.firstMatchIdSelected = this.firstMatchList.filter(item => {
              return item.match_id == (this.firstProvider == 'CMD' ? matchInfo.cmd_match_id : matchInfo.sbo_match_id);
            })[0].match_id;
            this.canFindPair = false;
          } else {
            this.firstMatchIdSelected = "";
            this.canFindPair = true;
          }
        }

        if (!this.canFindPair) {
          var VueScrollTo = require("vue-scrollto");

          var options = {
            container: type == "firstMatch" ? "#tblSecondMatch" : "#tblFirstMatch",
            offset: -200
          };

          var elem = type == "firstMatch" ? this.$refs[this.secondMatchIdSelected][0] : this.$refs[this.firstMatchIdSelected][0];

          VueScrollTo.scrollTo(elem, "500", options);
        }
      } else {
        if (type == "firstMatch") {
          setTimeout(() => {
            this.firstMatchIdSelected = matchInfo.match_id;
            this.firstMatchSelected = matchInfo;
          }, 1);
        } else if (type == "secondMatch") {
          setTimeout(() => {
            this.secondMatchIdSelected = matchInfo.match_id;
            this.secondMatchSelected = matchInfo;
          }, 1);
        }
      }
    },
    mapMatch: function() {
      this.$helpers
        .alert({
          title: this.$t("ui.combine.map_match"),
          text: this.$t("message.map_match_confirm"),
          type: "question",
          showCancelButton: true
        })
        .then(result => {
          if (result.value) {
            this.confirmMapMatch();
          }
        });
    },
    confirmMapMatch: function() {
      let url = config.mapMatchCMDSBOUrl();;

      var json = {
        action_by: this.$store.getters.username,
        session_token: this.$store.getters.sessionToken,
        page_id: config.accessRoles.cmdsbomapmatch,
        cmd_match: this.firstProvider.toLowerCase() == 'cmd' ? this.firstMatchIdSelected : this.secondMatchIdSelected,
        sbo_match: this.firstProvider.toLowerCase() == 'sbo' ? this.firstMatchIdSelected : this.secondMatchIdSelected,
      };

      this.feedback.success = true;
      this.loading = true;
      this.$http.post(url, json).then(
        function(response) {
          this.loading = false;
          // Success
          try {
            if (response) {
              this.feedback.success = typeof response.data.status == "string" ? response.data.status == "1" : response.data.status == 1;

              this.feedback.status = response.data.statusdesc;
              if (this.feedback.success == true) {
                this.getMatchList();
                this.$snotify.success(this.$t("message.success"));
              } else {
                this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
              }
            }
          } catch (error) {
            this.feedback.success = false;
            this.feedback.status = errorTags.request.failed;
            this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
          }
        },
        function(response) {
          this.loading = false;
          // Error
          this.feedback.success = false;
          this.feedback.status = errorTags.request.failed;
          this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
        }
      );
    },
    reset: function() {
      this.firstMatchIdSelected = "";
      this.secondMatchIdSelected = "";
    },
    handleFailed: function(tag, status) {
      this.$helpers.showDialog(this.$t("ui.combine." + tag), this.$t("error." + status), "error");
    }
  }
};
</script>
<style lang="scss" scoped>
tr,
td {
  cursor: pointer;
}
</style>